import React, { useEffect, useState } from "react";
import getAdminStats, { AdminStats } from "../../helpers/getAdminStats";
import { IconCode, IconUsers } from "./AdminIcons";
import "../../Admin.scss";

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const result = await getAdminStats();
      setStats(result.data);
      setLoading(false);
    };
    load();
  }, []);

  const cards = [
    {
      label: "Ukupno kodova",
      value: stats?.totalCodes ?? 0,
      tone: "yellow",
      icon: <IconCode />,
    },
    {
      label: "Jedinstveni igrači",
      value: stats?.uniquePlayers ?? 0,
      tone: "blue",
      icon: <IconUsers />,
    },
    {
      label: "Kodovi danas",
      value: stats?.codesToday ?? 0,
      tone: "dark",
      icon: <IconCode />,
    },
    {
      label: "Igrači danas",
      value: stats?.playersToday ?? 0,
      tone: "gold",
      icon: <IconUsers />,
    },
  ];

  return (
    <section className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Dashboard</h1>
          <p className="admin-lede">Pregled statistika Ultra NCP kampanje</p>
        </div>
      </header>

      {loading ? (
        <p className="admin-muted">Učitavanje...</p>
      ) : (
        <div className="admin-stats">
          {cards.map((card) => (
            <article key={card.label} className={`admin-stat-card is-${card.tone}`}>
              <div className={`admin-stat-icon is-${card.tone}`}>{card.icon}</div>
              <span>{card.label}</span>
              <strong>{card.value.toLocaleString("sr-RS")}</strong>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default AdminDashboard;
